import { ApplicationRef, ComponentFactoryResolver, DoBootstrap, DOCUMENT, Inject, NgModule, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';

import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { AllEconomicDataComponent } from 'IndicatorsApp/ts/features/all-economic-data-module/all-economic-data.component';
import { AllEconomicDataModule } from 'IndicatorsApp/ts/features/all-economic-data-module/all-economic-data.module';
import { ReportLinkComponent } from 'IndicatorsApp/ts/features/report-tooltip-module/report-link.component';

import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';

import { getLogger } from 'Angular/state/logger';

@NgModule({
    imports: [
        AllEconomicDataModule,
        BrowserModule,
        ConfigModule,
        NavigationModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() }),
    ],
})
export class AppModule implements DoBootstrap {
    static bootstrapComponents: Type<{}>[] = [AllEconomicDataComponent, TopBarNavComponent, ReportLinkComponent];

    constructor(@Inject(DOCUMENT) private _document: any, private componentFactoryResolver: ComponentFactoryResolver) {}

    ngDoBootstrap(applicationRef: ApplicationRef): void {
        AppModule.bootstrapComponents.forEach((component) => {
            const { selector } = this.componentFactoryResolver.resolveComponentFactory(component);
            const elements: Type<{}>[] = this._document.querySelectorAll(selector);
            elements.forEach((element) => {
                applicationRef.bootstrap(component, element);
            });
        });
    }
}
